import { render, staticRenderFns } from "./publish-reload-button.vue?vue&type=template&id=00b9f1a8"
import script from "./publish-reload-button.vue?vue&type=script&lang=js"
export * from "./publish-reload-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports